import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import isDevelopment from "utils/environment";

function DevModeBanner() {
  if (!isDevelopment) return null;

  return (
    <SoftBox
      sx={{
        position: "absolute",
        top: 24,
        left: -80,
        width: "100%",
        transform: "rotate(-45deg)",
        zIndex: 10,
        pointerEvents: "none",
      }}
    >
      <SoftBox
        sx={{
          backgroundColor: "error.main",
          py: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <SoftTypography
          sx={{
            color: "white.main",
            fontSize: 14,
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          DEV MODE
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

export default DevModeBanner;
